/**
 * Hoffmaster Gallery Grid Widget Handler
 * Widget name: hm_gallery_grid
 * Currently CSS-only, reserved for future interactive features.
 */

class HoffmasterGalleryGridHandler extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				grid: '.hm-gallery-grid',
				item: '.hm-gallery-grid__item',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings('selectors');
		return {
			$grid: this.$element.find(selectors.grid),
			$items: this.$element.find(selectors.item),
		};
	}

	bindEvents() {
		// Reserved for future interactive features
		// Examples:
		//   - Lightbox functionality
		//   - Hover effects
		//   - Image lazy loading
		//   - Masonry re-layout on window resize
	}
}

jQuery(window).on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler(
		'hm_gallery_grid',
		HoffmasterGalleryGridHandler
	);
});
